import React from "react";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import { Menu, Typography } from "antd";
import { useQuery } from "react-query";

// import HomeIcon from "@components/svg/HomeIcon";
import BidIcon from "@components/svg/BidIcon";
import UpNextIcon from "@components/svg/UpNextIcon";
import HistoryIcon from "@components/svg/HistoryIcon";
import RulesIcon from "@components/svg/RulesIcon";
import ResultsIcon from "@components/svg/ResultsIcon";
import LogoIcon from "@components/svg/LogoIcon/LogoIcon";
import TermsIcon from "@components/svg/TermsIcon";
import FaqIcon from "@components/svg/FaqIcon";
import DeliveryIcon from "@components/svg/DeliveryIcon";
import UserLogin from "@components/LeftMenu/components/UserLogin";
import UserBlock from "@components/LeftMenu/components/UserBlock";
import { getUserQuery, getRemainTurnQuery } from "@dataLayer/user";
import { PATHS } from "@config/constants";
import { ROUTES } from "@config/routes/_routes";

import "./index.scss";
import { useTranslation } from "react-i18next";
import HomeIcon from "@components/svg/HomeIcon";
import ThemeChanger from "./components/ThemeChanger/ThemeChanger";
import { useEffect } from "react";
import { getShowNotification, setShowNotification } from "@utils/cookie";
import { useState } from "react";
import BitelModalNoti from "@components/Modal/NotiModal";
import BidFreeModal from '@components/Modal/BidFreeModal';

const { Link } = Typography;

const LeftMenu = () => {
  const { data: user, isLoading } = useQuery(getUserQuery());
  const { data: currentPack } = useQuery(getRemainTurnQuery());

  const location = useLocation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  const handleClick = (e) => {
    history.push(e.key === "home" ? "/" : e.key);
  };
  // useEffect(() => {
  //   if (user) {
  //     if (!getShowNotification()) {
  //       setShowModal(true);
  //     }
  //   }
  // }, [user]);
  const handleCancel = () => {
    setShowModal(false);
    setShowNotification();
  };
  const getMatchedKey = (location) => {
    let matchLocation =
      ROUTES.find((route) => {
        return matchPath(location.pathname, route);
      }) || ROUTES[2];
    if (matchLocation?.parentPath) {
      return matchLocation?.parentPath;
    } else {
      return matchLocation?.path;
    }
  };

  return (
    <div className="left-menu-wrapper">
      <div className="left-menu">
        <div className="left-menu-top">
          <Link href={PATHS.BID_PAGE} className="brand-logo">
            <LogoIcon className="brand-logo-icon" />
          </Link>
          <div className="left-menu-bottom">
            {isLoading ? (
              <></>
            ) : user ? (
              <UserBlock user={user} currentPack={currentPack} />
            ) : (
              <UserLogin />
            )}
          </div>
          <Menu
            defaultSelectedKeys={[location.pathname]}
            mode="inline"
            selectedKeys={[getMatchedKey(location)]}
            onClick={handleClick}
            className="left-menu-block"
          >
            <Menu.Item key={PATHS.HOME_PAGE} icon={<HomeIcon />}>
              {t("left_menu.home")}
            </Menu.Item>
            {location.pathname === "/" ? (
              <Menu.Item key={PATHS.BID_PAGE} icon={<BidIcon />}>
                {t("left_menu.bid")}
              </Menu.Item>
            ) : (
              <Menu.Item key={PATHS.BID2_PAGE} icon={<BidIcon />}>
                {t("left_menu.bid")}
              </Menu.Item>
            )}
            <Menu.Item key={PATHS.RULES_PAGE} icon={<RulesIcon />}>
              {t("left_menu.rules")}
            </Menu.Item>
            <Menu.Item key={PATHS.UP_NEXT_PAGE} icon={<UpNextIcon />}>
              {t("left_menu.upcoming")}
            </Menu.Item>
            <Menu.Item key={PATHS.HISTORY_PAGE} icon={<HistoryIcon />}>
              {t("left_menu.finished")}
            </Menu.Item>
            <Menu.Item key={PATHS.RESULTS_PAGE} icon={<ResultsIcon />}>
              {t("left_menu.results")}
            </Menu.Item>
            <Menu.Item key={PATHS.TERM_PAGE} icon={<TermsIcon />}>
              {t("left_menu.term")}
            </Menu.Item>
            <Menu.Item key={PATHS.QUESTIONS_PAGE} icon={<FaqIcon />}>
              {t("left_menu.questions")}
            </Menu.Item>
            <Menu.Item key={PATHS.DELIVERY_PAGE} icon={<DeliveryIcon />}>
              ¿Cómo recibo mi premio si gané?
            </Menu.Item>
            <ThemeChanger />
          </Menu>
        </div>
      </div>
      {/* <BitelModalNoti
        message={t("modal.notification.content")}
        title={t("modal.notification.title")}
        visible={showModal}
        handleOk={handleCancel}
        handleCancel={handleCancel}
      /> */}
      {user && user?.isReceivedFreeBidToday ? (
        <BidFreeModal
          isReceivedFreeBidToday={user?.isReceivedFreeBidToday}
          message={user.message}
          userId={user?.id}
        />
      ) : null}
    </div>
  );
};

export default LeftMenu;
